<template>
  <v-modal
    name="phone-prompt"
    :title="$t('frontend_phoneprompt_title')"
    width="730px"
    :hideClose="true"
  >
    <div class="py-5 px-8">
      <p class="text-sm">{{ $t('frontend_phoneprompt') }}</p>
      <div class="mt-5 flex justify-center space-x-2">
        <div class="w-52">
          <div
            class="w-full relative h-10 border border-solid rounded-lg flex items-center text-grey-600 border-grey-200 bg-white"
          >
            <input
              type="text"
              class="w-full h-full outline-none rounded-lg px-4 bg-white"
              placeholder="+123456789"
              v-model="phone"
            />
          </div>
          <div v-if="errorMsg" class="mt-1 ml-2 text-primary-dark text-xs">
            {{ errorMsg }}
          </div>
        </div>
        <gd-button
          :disabled="!validatePhoneNumber"
          @click="addPhone"
          class="h-10"
          size="lg"
          variant="primary"
          >{{ $t(`frontend_phoneprompt_action`) }}</gd-button
        >
      </div>
    </div>
  </v-modal>
</template>
<script>
import GdButton from './Button';
import Dropdown from './Dropdown';
import VModal from './Modal';

export default {
  name: 'PhonePrompt',
  components: {
    VModal,
    Dropdown,
    GdButton
  },
  data() {
    return {
      phone: null
    };
  },
  computed: {
    errorMsg() {
      return this.validatePhoneNumber
        ? null
        : this.$t('frontend_phoneprompt_required');
    },
    validatePhoneNumber() {
      var re = /^\+?[1-9]{1}[0-9]{3,14}$/;
      return this.phone && re.test(this.phone);
    }
  },
  methods: {
    open() {
      this.phone = null;
      this.$root.$emit('modal-open', 'phone-prompt');
    },
    close() {
      this.$root.$emit('modal-close', 'phone-prompt');
    },
    addPhone() {
      this.$emit('submit', this.phone);
    }
  },
  watch: {}
};
</script>
